import React, { useContext, useEffect } from 'react';
import Configurator from '../components/configurator/Configurator';
import HandlesConfig from '../components/configurationOptions/HandlesConfig';
import ProgressBar from '../components/ProgressBar';
import { ConfiguratorModeContext } from '../contexts/ConfiguratorModeContext';

const WardrobeHandlesConfiguration = () => {
  const { setCurrentConfiguratorMode } = useContext(ConfiguratorModeContext);

  useEffect(() => {
    setCurrentConfiguratorMode(5);
    /* eslint-disable-next-line */
  }, []);

  return (
    <Configurator>
      <ProgressBar link="/wardrobe-fronts-configuration" activeLvl={1} />
      <HandlesConfig />
    </Configurator>
  );
};

export default WardrobeHandlesConfiguration;
